import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as customPriceActions from './../../../../../actions/customPriceAction';
import CustomPriceDetail from './CustomPriceDetail';

const mapStateToProps = state => {
    return {
        customPriceState: state.customPriceReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getCustomPriceDetail: (id) => dispatch(customPriceActions.getCustomPriceDetail(id)),
        setCustomPriceDetail: (price) => dispatch(customPriceActions.setCustomPriceDetail(price)),
        updateCustomPrice: (price) => dispatch(customPriceActions.updateCustomPrice(price)),
        createCustomPrice: (price) => dispatch(customPriceActions.createCustomPrice(price)),
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(CustomPriceDetail));
